import { useState } from "react";
import { BookOpen, Dumbbell } from "lucide-react";

export function OptionalContent({ oc }) {
  const [open, setOpen] = useState(false);
  if (!oc) return null;
  const reading = oc.type === "reading";
  const Icon = reading ? BookOpen : Dumbbell;
  return (
    <div className="rounded-2xl border border-dashed border-[#3F3F46] p-5" data-testid="c2g-optional">
      <button onClick={() => setOpen(!open)} data-testid="c2g-optional-toggle" className="flex w-full items-center gap-3 text-left">
        <Icon size={18} className="shrink-0 text-[#D4AF37]" />
        <span className="flex-1">
          <span className="block text-[12px] font-semibold uppercase tracking-wider text-[#8A8E96]">{reading ? "Lettura facoltativa" : "Esercizio facoltativo"} · non cambia le statistiche</span>
          <span className="text-base font-semibold text-[#F4F4F5]">{oc.title}</span>
        </span>
        <span className="text-sm text-[#D4AF37]">{open ? "Chiudi" : "Apri"}</span>
      </button>
      {open && reading && (
        <div className="mt-4 space-y-3" data-testid="c2g-reading-body">
          {oc.paragraphs.map((p, i) => <p key={i} className="a2g-read text-base leading-relaxed text-[#B4B4BC]">{p}</p>)}
        </div>
      )}
      {open && !reading && (
        <div className="mt-4" data-testid="c2g-exercise-body">
          <div className="space-y-1 a2g-read text-base text-[#B4B4BC]">
            <p><b className="text-[#D4D4D8]">Obiettivo:</b> {oc.objective}</p>
            <p><b className="text-[#D4D4D8]">Tempo:</b> {oc.duration}</p>
            <p><b className="text-[#D4D4D8]">Occorrente:</b> {oc.materials}</p>
          </div>
          <ol className="mt-3 space-y-2">
            {oc.steps.map((s, i) => (
              <li key={i} className="flex gap-2 a2g-read text-base text-[#D4D4D8]">
                <span className="tabular-nums flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#18181C] text-sm font-semibold text-[#D4AF37]">{i + 1}</span>
                <span className="pt-0.5">{s}</span>
              </li>
            ))}
          </ol>
          {oc.principle && <p className="mt-3 a2g-read text-base text-[#F4F4F5]"><b>Scelta:</b> {oc.principle}</p>}
        </div>
      )}
    </div>
  );
}
